module.exports = __webpack_public_path__ + "static/media/shareButton.57b14b6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/think/shareButton.svg
// module id = 1895
// module chunks = 0